import type { FC } from 'react';

import { StyledPolicyList } from '../components';
import PolicyItem from './PolicyItem';

export type Policy<K extends string = string> = Record<K, string | number | undefined>;

interface PolicyListProps {
    policy: Policy;
    error: string[];
}

const policies: Record<string, (number: number | string | undefined) => string> = {
    minLength: (number) => `Length must be greater than ${number}`,
    digitRequired: () => 'Password must contain numbers',
    specialCharacterRequired: () => 'Password must contain at least one special symbol',
    lowercaseLetterRequired: () => 'Password must contain at least one lowercase letter',
    uppercaseLetterRequired: () => 'Password must contain at least one uppercase letter',
    preventReuse: (number) => `Password cannot be one of the previous ${number} used passwords`,
    matchesEmail: () => `Password cannot be the same as email`,
    notCompromisedPassword: () => `Password was found on a blacklist`,
};

const PolicyList: FC<PolicyListProps> = ({ policy, error }) => (
    <StyledPolicyList>
        {Object.keys(policies)
            .filter((policyKey) => policy[policyKey])
            .map((policyKey) => (
                <PolicyItem passed={!error.includes(policyKey)} key={policyKey}>
                    {policies[policyKey](policy[policyKey])}
                </PolicyItem>
            ))}
    </StyledPolicyList>
);

export default PolicyList;
